export default function checkIfCanList({ next, store }) {
  let scopes = store.getters.userScopes;
  if (scopes.includes('system_company_list_all') || scopes.includes('system_company_list_company')) {
    return next();
  }
  return next({
    name: 'settings',
  });
}
